import { BaseFileUploaderAPI } from './base-file-uploader-api.js';
class FileUploaderAPI extends BaseFileUploaderAPI {
    /**
    * Returns the add file expression.
    */
    getAddFileExpression() {
        return this.state.addFileExpression;
    }
    /**
     * Sets the add file expression.
     *
     * @param addFileExpression - The add file expression.
     */
    setAddFileExpression(addFileExpression) {
        this.setState({ addFileExpression });
    }
    /**
    * Returns the allowed file types.
    */
    getAllowedTypes() {
        return this.state.allowedTypes;
    }
    /**
     * Sets the allowed file types.
     *
     * @param allowedTypes - The allowed file types.
     */
    setAllowedTypes(allowedTypes) {
        this.setState({ allowedTypes });
    }
    /**
    * Returns if the file uploader is enabled.
    */
    isEnabled() {
        return this.state.enabled;
    }
    /**
     * Sets if the file uploader is enabled.
     *
     * @param enabled - If the file uploader is enabled.
     */
    setEnabled(enabled) {
        this.setState({ enabled });
    }
    /**
    * Returns the FileHandler instance used by the FileUploader.
    */
    getFileHandlerInstance() {
        return this.state.fileHandlerInstance;
    }
    /**
    * Returns the name of the FileHandlerProvider used by the FileUploader.
    */
    getFileHandlerProviderName() {
        return this.state.fileHandlerProviderName;
    }
    /**
    * Sets the name of the FileHandlerProvider used by the FileUploader.
    *
    * @param fileHandlerProviderName - The name of the FileHandlerProvider used by the FileUploader.
    */
    setFileHandlerProviderName(fileHandlerProviderName) {
        this.setState({ fileHandlerProviderName });
    }
    /**
     * Sets the max file size options.
     *
     * @param maxFileSize - The max file size options.
     */
    setMaxFileSize(maxFileSize) {
        this.setState({ maxFileSize });
    }
    /**
    * Returns the max file size options.
    */
    getMaxFileSize() {
        return this.state.maxFileSize;
    }
    /**
    * Returns if the file uploader is read only.
    */
    isReadOnly() {
        return this.state.readOnly;
    }
    /**
     * Sets if the file uploader is read only.
     *
     * @param readOnly - If the file uploader is read only.
     */
    setReadOnly(readOnly) {
        this.setState({ readOnly });
    }
    /**
    * Returns if the file uploader is valid.
    */
    isValid() {
        return this.state.valid;
    }
    /**
     * Sets if the file uploader is valid.
     *
     * @param valid If the file uploader is valid.
     */
    setValid(valid) {
        this.setState({ valid });
    }
}
export { FileUploaderAPI, };
//# sourceMappingURL=file-uploader-api.js.map